import { createContext, useMemo, createElement, useState, useEffect, useContext } from 'react';
import uniqid from 'uniqid';
import PropTypes from 'prop-types';

function warnNoProvider() {
  // eslint-disable-next-line no-console
  console.warn("[constate] Missing Provider");
} // istanbul ignore next


var canUseProxy = process.env.NODE_ENV === "development" && typeof Proxy !== "undefined"; // istanbul ignore next

var defaultValue = canUseProxy ? new Proxy({}, {
  get: warnNoProvider,
  apply: warnNoProvider
}) : {};

function createContainer(useValue, createMemoInputs) {
  var Context = createContext(defaultValue);

  var Provider = function Provider(props) {
    var value = useValue(props); // createMemoInputs won't change between renders

    var memoizedValue = createMemoInputs ? useMemo(function () {
      return value;
    }, createMemoInputs(value)) : value;
    return createElement(Context.Provider, {
      value: memoizedValue
    }, props.children);
  };

  return {
    Context: Context,
    Provider: Provider
  };
}

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var joinTitles = function joinTitles(titles, divider) {
  return titles.map(function (item) {
    return item.string;
  }).filter(function (item) {
    return item;
  }).join(divider);
};

var useTitles = function useTitles(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$divider = _ref.divider,
      divider = _ref$divider === undefined ? ' - ' : _ref$divider,
      _ref$append = _ref.append,
      append = _ref$append === undefined ? false : _ref$append;

  var _useState = useState([]),
      _useState2 = slicedToArray(_useState, 2),
      titles = _useState2[0],
      setTitles = _useState2[1];

  useEffect(function () {
    var oldTitle = document.title;
    return function () {
      document.title = oldTitle;
    };
  }, []);
  useEffect(function () {
    var allTitles = [{
      string: title
    }].concat(toConsumableArray(titles));

    if (!append) {
      allTitles.reverse();
    }

    document.title = joinTitles(allTitles, divider);
  }, [titles, divider]);

  function register(object) {
    object.id = object.id ? object.id : uniqid();
    setTitles(function (state) {
      return [].concat(toConsumableArray(state), [object]);
    });
    return function unregister() {
      var id = object.id;
      setTitles(function (state) {
        return state.filter(function (item) {
          return item.id !== id;
        });
      });
    };
  }

  return {
    register: register,
    titles: titles
  };
};

var _createContainer = createContainer(useTitles),
    Provider = _createContainer.Provider,
    Context = _createContainer.Context;

function useTitle(string) {
  var context = useContext(Context);
  useEffect(function () {
    return context.register({
      string: string
    });
  }, []);
}

function Title(_ref) {
  var string = _ref.string;
  useTitle(string);
  return null;
}

Title.propTypes = {
  string: PropTypes.string.isRequired
};
export { useTitle, Title, Provider };